import I18n, { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { SanitizeHTMLString } from "@circle-react-uikit/SanitizeContent";
import { Typography } from "@circle-react-uikit/Typography";

interface AgentActiveCheckResponse {
  enabled: boolean;
  id: number;
  name: string;
}

interface DisabledAgentsContentProps {
  disabledAgents: AgentActiveCheckResponse[];
  onCancel: () => void;
  onPublish: () => void;
  variant?: "edit" | "cancel";
}

const formatBotNames = (agents: AgentActiveCheckResponse[]): string => {
  if (!agents || agents.length === 0) return "";

  const names = agents.map(agent => agent.name);

  if (names.length === 1) return names[0];

  const listFormatter = new Intl.ListFormat(I18n.locale, {
    style: "long",
    type: "conjunction",
  });

  return listFormatter.format(names);
};

export const DisabledAgentsContent = ({
  disabledAgents,
  onCancel,
  onPublish,
  variant = "edit",
}: DisabledAgentsContentProps) => {
  const getDismissButtonText = () =>
    variant === "edit"
      ? t("settings.workflows.confirm_modal.edit_workflow")
      : t("cancel");

  return (
    <Modal.Content size="lg">
      <Modal.Header>
        <Modal.Title>
          {t("settings.workflows.confirm_modal.ai_agent_currently_disabled", {
            count: disabledAgents.length,
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="space-y-4">
          <Typography.BodySm>
            <SanitizeHTMLString
              content={t(
                "settings.workflows.confirm_modal.ai_agent_disabled_description",
                {
                  count: disabledAgents.length,
                  bot_name: formatBotNames(disabledAgents),
                },
              )}
            />
          </Typography.BodySm>
        </div>
      </Modal.Body>

      <Modal.Footer className="flex w-full items-center justify-end gap-3">
        <Button variant="secondary" onClick={onCancel}>
          {getDismissButtonText()}
        </Button>
        <Button variant="circle" onClick={onPublish}>
          {t("settings.workflows.confirm_modal.enable_and_activate")}
        </Button>
      </Modal.Footer>
    </Modal.Content>
  );
};
